module.exports = __webpack_public_path__ + "img/paul3.598a516f.jpg";